/**
 * MSS Features tabs (WAI-ARIA tabs pattern, automatic activation).
 * Panels are stacked in one grid cell, so switching tabs never changes the section height.
 */
(() => {
  const init = (root) => {
    const tabs = Array.from(root.querySelectorAll('[data-mss-features-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-mss-features-panel]'));

    if (tabs.length < 2) {
      return;
    }

    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
        panels[i]?.classList.toggle('is-active', isActive);
      });

      if (focus) {
        tabs[index].focus();
        tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index, false));
      tab.addEventListener('keydown', (event) => {
        const last = tabs.length - 1;
        const next = {
          ArrowRight: index === last ? 0 : index + 1,
          ArrowLeft: index === 0 ? last : index - 1,
          Home: 0,
          End: last,
        }[event.key];

        if (next !== undefined) {
          event.preventDefault();
          select(next, true);
        }
      });
    });
  };

  const boot = () => document.querySelectorAll('[data-mss-features-tabs]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
